import React from "react";
import styled from "styled-components";

interface Props {
  readonly collapse?: string;
  readonly size: number;
  readonly className?: string;
  readonly align?: string;
}

// TODO: Add support for collapse
// const media = {
//   xs: (styles) => `
//         @media only screen and (max-width: 575.98px) {
//             ${styles}
//         }
//     `,
// };

const Block = styled.div<Props>`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: ${(props) => (props.size ? props.size : 1)};
  align-items: ${(props) => (props.align ? props.align : "start")};
`;

const Col: React.FC<Props> = ({ className, align, size, children }) => {
  return (
    <Block align={align} size={size} className={className}>
      {children}
    </Block>
  );
};

export default Col;
